
<div>
    <form [formGroup]="form">
        <div fxLayout="column" fxLayoutAlign="start">
            <div class="disabled" fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
                 fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
                <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                    <mat-label>Latitud*</mat-label>
                    <input matInput formControlName="lat" type="number">
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                    <mat-label>Longitud*</mat-label>
                    <input matInput formControlName="lng" type="number">
                </mat-form-field>
            </div>
        </div>
    </form>
    <!-- <div *ngIf="!showMap" fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                     fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch" style="margin-top: 10px;">
        <button mat-button color="primary" (click)="resizeAndShow()">Ver en mapa</button>
    </div> -->
    <div id="mapa-hide">
        <h2>Búsqueda en mapa</h2>
        <div class="flex flex-col flex-auto min-w-0">

            <!-- Main -->
            <div class="flex-auto p-6 sm:p-10">
                <form [formGroup]="formLoc">
                    <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                        fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">
                        <mat-form-field appearance="outline" fxFlex.xs="100%" fxFlex="33%" class="px-4">
                            <mat-label>Estado</mat-label>
                            <input matInput cleanWhiteSpace formControlName="estado" [maxLength]="75"
                                [required]="formLoc.get('estado').errors !== null && formLoc.get('estado').errors.required"
                                readonly="readOnly"
                            >
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex.xs="100%" fxFlex.sm="33%" class="px-4">
                            <mat-select placeholder="Seleccionar criterio" (selectionChange)="onFiltroChange($event)" formControlName="filtro" #selectFiter>
                                <mat-option>Limpiar...</mat-option>
                                <ng-container *ngFor="let filter of filters;">
                                    <mat-option [value]="filter.id">{{filter.title}}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <div fxFlex.xs="100%" fxFlex="33%">
                            <mat-form-field *ngIf='filtroSeleccionado == "municipio"' appearance="outline" class="px-4">
                                <mat-label>Municipio</mat-label>
                                <input matInput cleanWhiteSpace formControlName="municipio" [maxLength]="75"
                                    [required]="formLoc.get('municipio').errors !== null && formLoc.get('municipio').errors.required"
                                >
                            </mat-form-field>
                            <mat-form-field *ngIf='filtroSeleccionado == "cp"' appearance="outline" class="px-4">
                                <mat-label>CP</mat-label>
                                <input matInput cleanWhiteSpace formControlName="cp" [maxLength]="75"
                                    [required]="formLoc.get('cp').errors !== null && formLoc.get('cp').errors.required"
                                >
                            </mat-form-field>
                        </div>
                    </div>
                </form>

                <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                     fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch" style="margin-bottom: 16px;">
                    <button mat-button color="primary" (click)="buscarLocalizacion()" disabled='{{searchValid()}}'>Localizar en mapa</button>
                </div>

                <div class="content-map">
                    <evk-mapas></evk-mapas>
                </div>

            </div>

        </div>
    </div>
</div>
